import { useInfiniteQuery } from '@tanstack/react-query';
import { StationsFilter } from '@gettactic/api';
import { api } from '@/lib/api/api';

export function useStations(
  filters: StationsFilter,
  options: { enabled: boolean } = { enabled: true }
) {
  if (!filters.limit) {
    filters.limit = 100;
  }
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    status
  } = useInfiniteQuery(
    ['stations', filters],
    async ({ pageParam: cursor }) => {
      if (cursor) {
        filters.cursor = cursor;
      }
      const res = await api.client.stations.all(filters);
      return res.result;
    },
    {
      ...options,
      getNextPageParam: (lastPage) =>
        (lastPage?.elements.length ?? 0) < (filters.limit ?? 0)
          ? undefined
          : lastPage?.cursor ?? undefined
    }
  );

  return {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    status
  };
}
